// extracted by mini-css-extract-plugin
module.exports = {"bookList":"SimilarBooksView__bookList"};